<template>
  <div class="c-alert" :class="{ 'c-alert--center': center }">
    <div v-html="message" v-if="message" />
    <slot />
  </div>
</template>

<script>
// @group Base Components
export default {
  name: 'OAlert',
  props: {
    message: {
      type: String,
      default: null
    },
    center: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.c-alert {
  background: rgba($primary-color, 0.1);
  background: var(--primary-color-light);
  border-radius: $border-radius-small;
  color: $text-color;
  color: var(--text-color);
  line-height: 2rem;
  margin: 1.6rem 0;
  padding: 1.2rem 1.6rem;

  &:first-child {
    margin-top: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }

  a {
    border-bottom: 1px solid currentColor;
  }

  p:not(:last-child) {
    margin-bottom: 0.8rem;
  }

  ul,
  ol {
    font-size: 1.6rem;
    line-height: 2.4rem;
    padding-left: 1.6rem;
  }

  ul {
    list-style-type: disc;
  }

  li:not(:last-child) {
    margin-bottom: 0.8rem;
  }
}

.c-alert--center {
  text-align: center;
}
</style>
